import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineUserAdd } from "react-icons/ai";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import LoadableComponent from "../../../../features/Loading/LoadableComponent";
import { Ticket } from "../../../models/Ticket";
import getId from "../../../../utils/getId";
import { HiOutlineTicket } from "react-icons/hi";
import EAButton from "../../shared/Buttons/EAButton";

interface IProps {
  passesList: Ticket[];
  loading: boolean;
  joinToExercise: (value: boolean, passId: string) => void;
  reservationList: boolean;
  exerciseStart: number;
}

const ExerciseInfoPassSelector: React.FC<IProps> = ({ passesList, loading, joinToExercise, exerciseStart }) => {
  const { t } = useTranslation();
  const [showOptions, setShowOptions] = useState(false);

  const handleClickInOption = (value: boolean, id: string) => {
    joinToExercise(value, id);
    setShowOptions(false);
  };

  const getFilteredPassesList = () => {
    const filteredPassesList = passesList.filter(
      (item) => item.validfrom <= exerciseStart && exerciseStart <= item.validto
    );
    return filteredPassesList;
  };

  return (
    <LoadableComponent loading={loading}>
      {getFilteredPassesList().length > 1 ? (
        <>
          {showOptions ? (
            <div className="custom-select">
              <EAButton
                title={t("zapisz_sie_karnetem")}
                onClick={() => setShowOptions(false)}
                endIcon={<IoIosArrowDown />}
                variant="outlined"
              />
              <ul className="options-list shadow">
                {getFilteredPassesList().map((option) => (
                  <>
                    {option.ticket === false && (
                      <li
                        className="flex-between-center"
                        key={getId(option)}
                        onClick={() => handleClickInOption(false, getId(option))}
                      >
                        <div className="flex-start-center">
                          <HiOutlineTicket className="icon" /> {option.name}
                        </div>

                        {option.entrances - option.exercises.length <= 0 && (
                          <div className="alert-red alert alert-small">Wyczerpano</div>
                        )}
                      </li>
                    )}
                  </>
                ))}
              </ul>
            </div>
          ) : (
            <EAButton
              title={t("zapisz_sie_karnetem")}
              onClick={() => setShowOptions(true)}
              endIcon={<IoIosArrowUp />}
              variant="outlined"
            />
          )}
        </>
      ) : (
        <EAButton
          title={t("zapisz_sie_karnetem")}
          onClick={() => joinToExercise(false, "null")}
          endIcon={<AiOutlineUserAdd />}
          variant="outlined"
        />
      )}
    </LoadableComponent>
  );
};

export default ExerciseInfoPassSelector;
